import styled, { css } from 'styled-components/macro';

export const ScAccordion = styled.div``;

export const ScAccordionItem = styled.div<{ isTransparent?: boolean }>`
  ${({ isTransparent }) =>
    isTransparent
      ? css`
          padding-block: 12px;
          &:not(:first-child) {
            border-top: ${({ theme }) => `1px solid  ${theme.grayColor6}`};
          }
        `
      : css`
          &:not(:last-child) {
            margin-bottom: 8px;
          }
        `}
`;

export const ScAccordionItemTitle = styled.div<{
  isOpen: boolean;
  isTransparent?: boolean;
}>`
  position: relative;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: 0.3s;

  .inner {
    position: relative;
    z-index: 2;
    max-width: calc(100% - 40px);
  }

  .arrow {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 0;
    top: calc(50% - 10px);
    z-index: 3;
    transition: 0.3s;
    transform: rotate(0deg);
    transform-origin: center center;

    svg {
      width: 100%;
      height: 100%;

      path {
        transition: 0.3s;
      }
    }
  }
  @media (hover: hover) {
    &:hover {
      color: ${({ theme }) => theme.whiteColor};
      svg path {
        fill: ${({ theme }) => theme.whiteColor};
        fill-opacity: 1;
      }
    }
  }

  ${({ isOpen, isTransparent }) =>
    isOpen && !isTransparent
      ? css`
          border-color: rgba(255, 255, 255, 0.2);
          color: ${({ theme }) => theme.whiteColor};

          .arrow {
            transform: rotate(180deg);
          }
        `
      : css`
          color: ${({ theme }) => theme.secondaryColor};
        `}

  ${({ isTransparent }) =>
    isTransparent
      ? css`
          background: transparent;
          .inner {
            font-size: 14px;
            font-weight: 700;
            line-height: 20px;
            letter-spacing: 0;
          }
        `
      : css`
          background: ${({ theme }) => theme.secondaryColor2};
          border: 2px solid transparent;
          padding: 10px 14px;
        `}

  ${({ isOpen, isTransparent }) =>
    isOpen && isTransparent
      ? css`
          color: ${({ theme }) => theme.whiteColor};

          .arrow {
            transform: rotate(180deg);
          }
        `
      : css`
          color: ${({ theme }) => theme.secondaryColor};
        `}
`;

export const ScAccordionItemBody = styled.div<{ isTransparent?: boolean }>`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  width: calc(100% - 28px);

  .inner {
    padding: 16px;
    white-space: pre-line;

    p {
      ${({ isTransparent }) =>
        !isTransparent &&
        css`
          margin-bottom: 16px;
        `}
    }
    ul,
    ol {
      margin-bottom: 16px;
      margin-left: 1em;
      li {
        &:not(:last-child) {
          margin-bottom: 8px;
        }
      }
    }
    & > *:last-child {
      margin-bottom: 0;
    }
  }

  ${({ isTransparent }) =>
    isTransparent
      ? css`
          background: transparent;

          .inner {
            padding: 8px 0 0;
          }
        `
      : css`
          border-radius: 0 0 4px 4px;
          background: ${({ theme }) => theme.secondaryColor2};
        `}
`;
